import React, { useEffect } from 'react';
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic';
import { TableHeader } from '../../components/Table/TableHeader';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import { isNil } from 'lodash';
import { parseToFloat } from '../../utils/Utils';

const ViewTakaDetails = ({
    viewTakaDetailsModalOpen,
    setViewTakaDetailsModalOpen,
    currentTakaDetailsIndex,
    setCurrentTakaDetailsIndex,
    formik,
}) => {
    useEffect(() => {
        if (!viewTakaDetailsModalOpen) {
            setCurrentTakaDetailsIndex(null);
        }
    }, [viewTakaDetailsModalOpen]);
    const tableHeader = [
        {
            name: 'grey Meter',
        },
        {
            name: 'Mill Meter',
        },
        {
            name: 'Shortage',
        },
        {
            name: 'Best Output',
        },
    ];

    console.log(currentTakaDetailsIndex, 'cdi');
    return (
        <ModalBasic
            modalOpen={viewTakaDetailsModalOpen}
            setModalOpen={setViewTakaDetailsModalOpen}
        >
            {!isNil(currentTakaDetailsIndex) && (
                <div className="p-4">
                    <table>
                        <TableHeader headers={tableHeader} />
                        <tbody>
                            {formik?.values?.poData?.[
                                currentTakaDetailsIndex
                            ]?.takaDetails?.map?.((ele, i) => (
                                <tr>
                                    <td>
                                        <FormikInputGroup
                                            label="Grey Mt"
                                            name={`poData.${currentTakaDetailsIndex}.takaDetails.${i}.greyMt`}
                                            readOnly
                                            formik={formik}
                                        />
                                    </td>
                                    <td>
                                        <FormikInputGroup
                                            label="mill Mt"
                                            name={`poData.${currentTakaDetailsIndex}.takaDetails.${i}.millMt`}
                                            readOnly
                                            formik={formik}
                                        />
                                    </td>
                                    <td>
                                        <FormikInputGroup
                                            label="Shortage"
                                            name={`poData.${currentTakaDetailsIndex}.takaDetails.${i}.shortage`}
                                            formik={formik}
                                            // value={computeShortage(
                                            //     formik.values.poData[
                                            //         currentTakaDetailsIndex
                                            //     ].takaDetails[i].greyMt,
                                            //     formik.values.poData[
                                            //         currentTakaDetailsIndex
                                            //     ].takaDetails[i].millMt
                                            // )}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <FormikInputGroup
                                            label="Best Output"
                                            name={`poData.${currentTakaDetailsIndex}.takaDetails.${i}.bestOutput`}
                                            formik={formik}
                                            // value={Math.floor(
                                            //     parseFloat(
                                            //         formik.values.poData[
                                            //             currentTakaDetailsIndex
                                            //         ].takaDetails[i].millMt
                                            //     ) /
                                            //         parseFloat(
                                            //             formik.values.cut
                                            //         )
                                            // )}
                                            readOnly
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </ModalBasic>
    );
};

export default ViewTakaDetails;
